document.documentElement.classList.remove('no-js');

class MobileMenu {
  constructor(root) {
    this.root = root;
    this.drawer = root.querySelector('[data-mobile-drawer]');
    this.toggles = root.querySelectorAll('[data-mobile-toggle]');
    this.toggles.forEach((button) => button.addEventListener('click', () => this.toggle()));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !this.drawer?.hidden) this.close(); });
  }
  toggle() { this.drawer?.hidden ? this.open() : this.close(); }
  open() {
    if (!this.drawer) return;
    this.drawer.hidden = false;
    document.body.classList.add('is-locked');
    this.toggles.forEach((button) => button.setAttribute('aria-expanded', 'true'));
  }
  close() {
    if (!this.drawer) return;
    this.drawer.hidden = true;
    document.body.classList.remove('is-locked');
    this.toggles.forEach((button) => button.setAttribute('aria-expanded', 'false'));
  }
}

document.querySelectorAll('[data-header]').forEach((el) => new MobileMenu(el));

class VehicleFinder {
  constructor(root) {
    this.root=root; this.entries=[];
    this.make=root.querySelector('[data-make]'); this.model=root.querySelector('[data-model]');
    this.year=root.querySelector('[data-year]'); this.part=root.querySelector('[data-part]');
    this.button=root.querySelector('[data-find]');
    if(!this.make||!this.model||!this.year||!this.part||!this.button)return;
    this.bind(); this.load();
  }
  async load(){
    try{
      const res=await fetch(this.root.dataset.fitmentUrl,{credentials:'same-origin'});
      if(!res.ok) throw new Error('Fitment data unavailable');
      this.entries=await res.json();
    }catch(_){this.entries=[];}
    this.populateMakes(); this.syncButton();
  }
  unique(items){return [...new Set(items.filter(v=>v!==''&&v!=null))].sort((a,b)=>String(a).localeCompare(String(b),undefined,{numeric:true}));}
  option(value,label=value){const o=document.createElement('option');o.value=value;o.textContent=label;return o;}
  reset(sel,label){sel.innerHTML='';sel.appendChild(this.option('',label));sel.disabled=true;}
  populate(sel,values,label){this.reset(sel,label);values.forEach(v=>sel.appendChild(this.option(v)));sel.disabled=!values.length;}
  baseFiltered(){
    return this.entries.filter(e=>(!this.make.value||e.make===this.make.value)&&(!this.model.value||e.model===this.model.value));
  }
  yearMatches(entry){
    if(!this.year.value)return true;
    const y=Number(this.year.value); return y>=Number(entry.range_start)&&y<=Number(entry.range_end);
  }
  candidates(){
    return this.baseFiltered().filter(e=>this.yearMatches(e)&&(!this.part.value||e.part===this.part.value));
  }
  allYears(){
    const years=new Set();
    this.baseFiltered().forEach(e=>{for(let y=Number(e.range_start);y<=Number(e.range_end);y++)years.add(y);});
    return [...years].sort((a,b)=>b-a);
  }
  populateMakes(){
    this.populate(this.make,this.unique(this.entries.map(e=>e.make)),'Select make');
    this.make.disabled=!this.entries.length;
    this.reset(this.model,'Select model');this.reset(this.year,'Select year');this.reset(this.part,'Select part');
  }
  syncButton(){this.button.disabled=!(this.make.value&&this.model.value&&this.year.value&&this.part.value);}
  bind(){
    this.make.addEventListener('change',()=>{
      const models=this.unique(this.entries.filter(e=>e.make===this.make.value).map(e=>e.model));
      this.populate(this.model,models,'Select model');this.reset(this.year,'Select year');this.reset(this.part,'Select part');this.syncButton();
    });
    this.model.addEventListener('change',()=>{
      this.populate(this.year,this.allYears(),'Select year');this.reset(this.part,'Select part');this.syncButton();
    });
    this.year.addEventListener('change',()=>{
      this.populate(this.part,this.unique(this.baseFiltered().filter(e=>this.yearMatches(e)).map(e=>e.part)),'Select part');this.syncButton();
    });
    this.part.addEventListener('change',()=>this.syncButton());
    this.button.addEventListener('click',()=>{
      const matches=this.candidates();
      if(!matches.length)return;
      const selectedYear=Number(this.year.value);
      matches.sort((a,b)=>{
        const ae=Number(a.donor_year)===selectedYear?0:1, be=Number(b.donor_year)===selectedYear?0:1;
        if(ae!==be)return ae-be;
        return Math.abs(Number(a.donor_year)-selectedYear)-Math.abs(Number(b.donor_year)-selectedYear);
      });
      if(matches[0]?.url)window.location.href=matches[0].url;
    });
  }
}
document.querySelectorAll('[data-vehicle-finder]').forEach(el=>new VehicleFinder(el));

class ProductGallery {
  constructor(root){ this.root=root; this.buttons=[...root.querySelectorAll('[data-media-target]')]; this.media=[...root.querySelectorAll('[data-media-id]')]; this.buttons.forEach(btn=>btn.addEventListener('click',()=>this.show(btn.dataset.mediaTarget,btn))); }
  show(id,button){ this.media.forEach(item=>item.classList.toggle('is-hidden',String(item.dataset.mediaId)!==String(id))); this.buttons.forEach(btn=>btn.classList.remove('is-active')); button.classList.add('is-active'); }
}
document.querySelectorAll('[data-product-gallery]').forEach(el=>new ProductGallery(el));

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-vehicle-finder]').forEach(el=>new VehicleFinder(el));
    event.target.querySelectorAll('[data-header]').forEach(el=>new MobileMenu(el));
  });
}

class ProductPageEnhancer {
  constructor(root){
    this.root=root;
    this.form=root.querySelector('[data-product-form]');
    this.variantSelect=root.querySelector('[data-variant-select]');
    this.qty=root.querySelector('[data-qty-input]');
    this.mobileAdd=root.querySelector('[data-mobile-add]');
    try{this.variants=JSON.parse(root.querySelector('[data-product-variants]')?.textContent||'[]');}catch(e){this.variants=[];}
    root.querySelector('[data-qty-minus]')?.addEventListener('click',()=>this.changeQty(-1));
    root.querySelector('[data-qty-plus]')?.addEventListener('click',()=>this.changeQty(1));
    this.variantSelect?.addEventListener('change',()=>this.updateVariant());
    this.mobileAdd?.addEventListener('click',()=>this.form?.requestSubmit());
    this.form?.addEventListener('submit',()=>this.setLoading(true));
    this.updateVariant();
  }
  changeQty(delta){if(!this.qty)return;this.qty.value=Math.max(1,(parseInt(this.qty.value,10)||1)+delta);}
  money(cents){try{return new Intl.NumberFormat(document.documentElement.lang||'en-IE',{style:'currency',currency:'EUR'}).format((cents||0)/100);}catch(e){return `€${((cents||0)/100).toFixed(2)}`;}}
  selectedVariant(){const id=Number(this.variantSelect?.value || this.form?.querySelector('[name="id"]')?.value);return this.variants.find(v=>Number(v.id)===id) || this.variants[0];}
  updateVariant(){const v=this.selectedVariant();if(!v)return;
    this.root.querySelectorAll('[data-product-price],[data-mobile-price]').forEach(el=>el.textContent=this.money(v.price));
    this.root.querySelectorAll('[data-product-sku],[data-product-sku-secondary]').forEach(el=>el.textContent=v.sku||'—');
    const availability=this.root.querySelector('[data-product-availability]');
    if(availability){availability.classList.toggle('is-out',!v.available);availability.innerHTML=`<span></span>${v.available?'In stock & ready to dispatch':'Currently unavailable'}`;}
    this.root.querySelectorAll('[data-product-availability-short]').forEach(el=>el.textContent=v.available?'In stock':'Out of stock');
    const add=this.root.querySelector('[data-add-to-cart]');if(add){add.disabled=!v.available;const span=add.querySelector('span');if(span)span.textContent=v.available?'Add to cart':'Sold out';}
    if(this.mobileAdd){this.mobileAdd.disabled=!v.available;const span=this.mobileAdd.querySelector('span');if(span)span.textContent=v.available?'Add to cart':'Sold out';}
    if(history.replaceState && this.variantSelect){const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);}
  }
  setLoading(loading){const add=this.root.querySelector('[data-add-to-cart]');if(!add)return;add.classList.toggle('is-loading',loading);if(loading){const span=add.querySelector('span');if(span)span.textContent='Adding…';}}
}
document.querySelectorAll('[data-product-section]').forEach(el=>new ProductPageEnhancer(el));
document.querySelectorAll('[data-product-section]').forEach(root=>{
  const bar=root.querySelector('[data-mobile-buybar]');
  const mainButton=root.querySelector('[data-add-to-cart]');
  if(!bar||!mainButton||!('IntersectionObserver' in window)) return;
  const wmPdpStickyObserver=new IntersectionObserver(entries=>{
    entries.forEach(entry=>bar.classList.toggle('is-visible',!entry.isIntersecting));
  },{threshold:.05});
  wmPdpStickyObserver.observe(mainButton);
});

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-product-section]').forEach(el=>new ProductPageEnhancer(el));
  });
}

/* WiperMotors v6.9 — infinite Recently Added feed */
class InfiniteProducts {
  constructor(root) {
    this.root = root;
    this.grid = root.querySelector('[data-infinite-grid]');
    this.sentinel = root.querySelector('[data-infinite-sentinel]');
    this.progress = root.querySelector('[data-infinite-progress]');
    this.loading = false;
    this.done = !this.sentinel;
    this.observer = null;
    if (!this.grid || !this.sentinel) return;
    this.observe();
  }

  observe() {
    if (!('IntersectionObserver' in window)) {
      const fallback = this.sentinel.querySelector('.wm-infinite-loader__fallback');
      if (fallback) fallback.style.display = 'inline-flex';
      const spinner = this.sentinel.querySelector('.wm-infinite-loader__spinner');
      const text = this.sentinel.querySelector('[data-loader-text]');
      if (spinner) spinner.style.display = 'none';
      if (text) text.style.display = 'none';
      return;
    }
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some(entry => entry.isIntersecting)) this.loadNext();
    }, { rootMargin: '900px 0px 900px 0px', threshold: 0.01 });
    this.observer.observe(this.sentinel);
  }

  async loadNext() {
    if (this.loading || this.done || !this.sentinel) return;
    const nextUrl = this.sentinel.dataset.nextUrl;
    if (!nextUrl) return this.finish();

    this.loading = true;
    this.sentinel.classList.add('is-loading');
    this.sentinel.setAttribute('aria-busy', 'true');

    try {
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', this.root.dataset.sectionId);
      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const incomingGrid = doc.querySelector('[data-infinite-grid]');
      if (!incomingGrid) throw new Error('Product grid missing from response');

      [...incomingGrid.children].forEach(card => this.grid.appendChild(card));

      const incomingSentinel = doc.querySelector('[data-infinite-sentinel]');
      if (incomingSentinel?.dataset.nextUrl) {
        this.sentinel.dataset.nextUrl = incomingSentinel.dataset.nextUrl;
        this.sentinel.classList.remove('is-loading');
        this.sentinel.removeAttribute('aria-busy');
      } else {
        this.finish();
      }

      this.updateProgress(doc);
    } catch (error) {
      console.warn('Recently Added could not load the next batch.', error);
      this.sentinel.classList.remove('is-loading');
      this.sentinel.removeAttribute('aria-busy');
      const spinner = this.sentinel.querySelector('.wm-infinite-loader__spinner');
      const text = this.sentinel.querySelector('[data-loader-text]');
      const fallback = this.sentinel.querySelector('.wm-infinite-loader__fallback');
      if (spinner) spinner.style.display = 'none';
      if (text) text.textContent = 'Couldn’t load more automatically.';
      if (fallback) fallback.style.display = 'inline-flex';
    } finally {
      this.loading = false;
    }
  }

  updateProgress(doc) {
    if (!this.progress) return;
    const incomingCount = doc.querySelector('[data-infinite-count]');
    const currentCount = this.progress.querySelector('[data-infinite-count]');
    if (incomingCount && currentCount) currentCount.textContent = incomingCount.textContent;
  }

  finish() {
    this.done = true;
    if (this.observer && this.sentinel) this.observer.unobserve(this.sentinel);
    const complete = document.createElement('div');
    complete.className = 'wm-infinite-loader wm-infinite-loader--complete';
    complete.setAttribute('data-infinite-complete', '');
    complete.innerHTML = '<span class="wm-infinite-loader__tick">✓</span><span>You’ve reached the end of Recently Added.</span>';
    this.sentinel?.replaceWith(complete);
    this.sentinel = null;
  }
}

document.querySelectorAll('[data-infinite-products]').forEach(el => new InfiniteProducts(el));

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-infinite-products]').forEach(el => new InfiniteProducts(el));
  });
}


/* WiperMotors v6.10.1 — safe same make/model "See also" recommendations */
class WMVehicleRelatedProducts {
  constructor(root) {
    this.root = root;
    this.grid = root.querySelector('[data-vehicle-related-grid]');
    this.makeLabel = (root.dataset.make || '').trim();
    this.modelLabel = (root.dataset.model || '').trim();
    this.make = this.makeLabel.toLowerCase();
    this.model = this.modelLabel.toLowerCase();
    this.currentHandle = root.dataset.currentHandle || '';
    this.indexUrl = root.dataset.indexUrl || '';
    if (this.grid && this.make && this.model && this.indexUrl) this.load();
  }
  tagValue(tags, key) {
    const prefix = key.toLowerCase() + ':';
    const item = String(tags || '').split(',').map(v => v.trim())
      .find(v => v.toLowerCase().startsWith(prefix));
    return item ? item.slice(item.indexOf(':') + 1).trim() : '';
  }
  escapeHTML(value) {
    const d = document.createElement('div');
    d.textContent = value == null ? '' : String(value);
    return d.innerHTML;
  }
  money(value) {
    return new Intl.NumberFormat('en-IE', {style:'currency', currency:'EUR'}).format(Number(value || 0));
  }
  imageUrl(src, w=640) { try { const u=new URL(src, location.origin); if(u.hostname.includes('shopify.com')) u.searchParams.set('width', String(w)); return u.toString(); } catch (_) { return src || ''; } }
  card(p) {
    const title = this.escapeHTML(p.title);
    const url = this.escapeHTML(p.url);
    const vendor = this.escapeHTML(p.vendor || '');
    const sku = this.escapeHTML(p.sku || '');
    const image = this.escapeHTML(this.imageUrl(p.image || '', 640));
    const stock = !!p.available;
    return `<article class="wm-product-card-v3">
      <a class="wm-product-card-v3__media" href="${url}" aria-label="${title}">
        <img src="${image}" alt="${title}" loading="lazy" width="800" height="600">
        <span class="wm-product-card-v3__fit-check">✓ Fitment support</span>
      </a>
      <div class="wm-product-card-v3__body">
        <div class="wm-product-card-v3__meta"><span>${vendor}</span>${sku ? `<span>SKU ${sku}</span>` : ''}</div>
        <a class="wm-product-card-v3__title" href="${url}">${title}</a>
        <div class="wm-product-card-v3__fitment">Same ${this.escapeHTML(this.makeLabel)} ${this.escapeHTML(this.modelLabel)} range</div>
        <div class="wm-product-card-v3__status">${stock ? '<span class="is-live"></span><strong>In stock</strong><em>Ready to dispatch</em>' : '<span></span><strong>Out of stock</strong>'}</div>
        <div class="wm-product-card-v3__foot"><div class="wm-product-card-v3__price"><strong>${this.money(p.price)}</strong></div><span class="wm-product-card-v3__view">View part →</span></div>
      </div>
    </article>`;
  }
  async load() {
    try {
      const r = await fetch(this.indexUrl, {credentials:'same-origin'});
      if (!r.ok) return;
      const products = await r.json();
      const matches = products.filter(p => {
        const make = String(p.make || p.vendor || '').trim().toLowerCase();
        const model = this.tagValue(p.tags, 'FitmentModel').toLowerCase();
        const motor = /wiper\s+motor/i.test(String(p.title || '')) ||
                      /wiper\s+motor/i.test(String(p.tags || ''));
        return p.handle !== this.currentHandle &&
               make === this.make &&
               model === this.model &&
               motor &&
               p.image;
      }).slice(0, 4);
      if (!matches.length) return;
      const liveMatches = await Promise.all(matches.map(async p => {
        try {
          const liveUrl = String(p.url || '').replace(/\/$/, '') + '.js';
          const lr = await fetch(liveUrl, {credentials:'same-origin'});
          if (!lr.ok) return {...p, available:false};
          const live = await lr.json();
          return {
            ...p,
            available: !!live.available || (Array.isArray(live.variants) && live.variants.some(v => v.available)),
            price: typeof live.price !== 'undefined' ? Number(live.price) / 100 : p.price,
            sku: (live.variants && live.variants[0] && live.variants[0].sku) || p.sku
          };
        } catch (_) {
          return {...p, available:false};
        }
      }));
      this.grid.innerHTML = liveMatches.map(p => this.card(p)).join('');
      this.root.hidden = false;
    } catch (_) {}
  }
}
document.querySelectorAll('[data-vehicle-related]').forEach(el => new WMVehicleRelatedProducts(el));
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', e => {
    e.target.querySelectorAll('[data-vehicle-related]').forEach(el => new WMVehicleRelatedProducts(el));
  });
}
